import { MessageType } from '../../components/Message/types/messages';
import { TranscriptContextState } from './types';

/**
 * Returns the initial state for the transcript context
 * @param {string} initialSessionId
 * @param {MessageType} initialMessage
 * @returns {TranscriptContextState}
 */
export const getInitialTranscriptContextState = (
  initialSessionId: string = '',
  initialMessage?: MessageType,
  placeholderMessage?: MessageType,
): TranscriptContextState => ({
  isAwaitingServerMessage: false,
  loadFailed: false,
  messages: placeholderMessage ? [placeholderMessage] : [],
  sessionId: initialSessionId,
  isSessionActive: false,
  initialMessage: initialMessage,
  expandedSources: new Set(),
});
